import settings from 'Cloud/settings';
import { pathOr } from 'ramda';

/* Параметр mode прилетает с SSR и остаётся неизменным до перезагрузки страницы. */
const { mode = '' } = pathOr({}, ['request', 'query_params'], settings) as { mode?: string };

export const getIsPwaMode = () => mode === 'standalone';

export const isInStandaloneMode = () => {
    if (typeof window === 'undefined') {
        return false;
    }

    return ('navigator' in window && window.navigator['standalone']) || document.referrer.includes('android-app://') || getIsPwaMode();
};
